import {svgIconWrapper} from '../svg-icon-wrapper';

import MightyFormsRegular from './mighty-forms-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    const {fill: _fill, color: _color, ...rest} = props;

    return <MightyFormsRegular {...rest} />;
}

SvgComponent.iconName = 'mightyFormsRegular';

export const MightyFormsRegularIcon = svgIconWrapper(SvgComponent);
